import React from 'react';
import { ModalBody, ModalHeader, Row, Col, Modal } from 'reactstrap';
import ProgressBox from '@components/ProgressBox/ProgressBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Css from './AirportsModal.scss';

const airportsModal = props => {
  let airports = [];
  let conditionalAirports = [];

  if (props.airports.length > 0) {
    props.airports.map(item => {
      if (
        item.typeCesna === 'Conditional Airport' ||
        item.typePhenom === 'Conditional Airport' ||
        item.typeL650 === 'Conditional Airport'
      ) {
        conditionalAirports.push(item);
      } else {
        airports.push(item);
      }
      return item;
    });
  }

  return (
    <Modal
      isOpen={props.modalActive}
      toggle={props.toggleModal}
      className={'modal-lg'}
    >
      <ModalHeader toggle={props.toggleModal}>
        Select a Region/State and an Airport
      </ModalHeader>
      <ModalBody style={{ backgroundColor: '#ffffff' }} className={'p-0'}>
        {props.loading && (
          <ProgressBox
            text={'Submitting ...'}
            icon={<FontAwesomeIcon icon={['far', 'spinner']} spin />}
          />
        )}
        <Row>
          <Col lg={3} md={12}>
            <div className={props.isMobile ? ' pb-0 pt-4 px-4' : 'p-4'}>
              <div className={'font-lg color-red lakes-demibold pb-2'}>
                Region
              </div>
              <Row>
                {props.regions.map(item => {
                  return (
                    <Col
                      xs={6}
                      sm={6}
                      md={12}
                      key={item}
                      className={
                        Css.region +
                        ' mb-2 text-center lakes-medium pointer ' +
                        (props.activeRegion === item ? Css.active : '') +
                        (props.isMobile ? ' py-2' : ' p-2')
                      }
                      onClick={() => props.onRegionChange(item)}
                    >
                      {item}
                    </Col>
                  );
                })}
              </Row>
            </div>
          </Col>
          <Col
            lg={9}
            md={12}
            className={Css.cities + (props.isMobile ? '' : ' pl-0')}
          >
            {props.activeRegion === 'United States' && (
              <div
                className={
                  Css.states + (props.isMobile ? ' px-4 pt-2 pb-4' : ' p-4')
                }
              >
                <div className={'font-lg color-red lakes-demibold pb-2'}>
                  States
                </div>
                <select
                  className={'form-control'}
                  onChange={e => props.onStateChange(e.currentTarget)}
                >
                  {props.states.map(state => {
                    return (
                      <option key={state.state} value={state.state}>
                        {state.state}
                      </option>
                    );
                  })}
                </select>
              </div>
            )}

            <div className={'p-4 font-sm'}>
              <Row>
                {airports.map(item => {
                  return (
                    <Col xs={6} sm={4} key={item.airportID} className={'px-2'}>
                      <div
                        className={
                          'p-1 lakes-demibold color-red ' + Css.airport
                        }
                        onClick={() => props.onAirportSelect(item)}
                      >
                        {item.city} ({item.icaoCode}){' '}
                        {item.typePhenom === 'Prohibited Airport' && (
                          <span>(P300 Only)</span>
                        )}
                      </div>
                    </Col>
                  );
                })}
              </Row>
              <Row>
                {conditionalAirports.map(item => {
                  return (
                    <Col xs={6} sm={4} key={item.airportID} className={'px-2'}>
                      <div
                        className={'p-1 lakes-demibold ' + Css.airport}
                        onClick={() => props.onAirportSelect(item)}
                      >
                        {item.city} ({item.icaoCode}){' '}
                        {item.typePhenom === 'Prohibited Airport' && (
                          <span>(P300 Only)</span>
                        )}
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </Col>
        </Row>
        <div className={Css.disclaimers}>
          <Row>
            <Col md={12} lg={{ offset: 3, size: 9 }}>
              <div
                className={props.isMobile ? 'px-4 py-3 font-sm' : 'p-4 font-sm'}
              >
                <div className={'color-red'}>
                  *These airports can be used with very few limitations and in
                  most weather
                </div>
                <div>
                  *These airports may be subject to weather, temperature, curfew
                  or other limitations.
                  <br />
                  Usability will be confirmed at time of booking and/or by
                  condition on day of flight.
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default airportsModal;



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/FlightInfo/AirportsModal/AirportsModal.jsx